import _extends from "@babel/runtime-corejs3/helpers/extends";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import logger from "../../../util/logger";
import React from 'react';
import cx from 'classnames';
import { default as RCSlider } from 'rc-slider';
import * as _ from "../../../util/lodash";
import { positions } from "../../../enums";
import { createComponent, PropTypes } from "../../../wayin-react";
import Label from "../../core/label";
import { whitelistStyles } from "../../core/hoc";
var Slider = createComponent({
  displayName: 'Slider',
  propTypes: {
    id: PropTypes.string,
    value: PropTypes.number,
    label: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    stepSize: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string
    })),
    stepLabelPosition: PropTypes.oneOf([positions.RIGHT, positions.BOTTOM]),
    stepLabelWidth: PropTypes.number,
    formatStepLabel: PropTypes.func,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBeforeChange: PropTypes.func,
    onAfterChange: PropTypes.func,
    isFluid: PropTypes.bool,
    animationEnabled: PropTypes.bool
  },
  defaultProps: {
    id: '',
    value: 0,
    label: undefined,
    minValue: undefined,
    maxValue: undefined,
    stepSize: undefined,
    steps: [],
    stepLabelPosition: undefined,
    stepLabelWidth: undefined,
    formatStepLabel: function formatStepLabel(x) {
      return _.identity(x);
    },
    isDisabled: false,
    onChange: _.noop,
    onBeforeChange: _.noop,
    onAfterChange: _.noop,
    isFluid: true,
    animationEnabled: true
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  state: {
    _sliderValue: {
      value: function value(p) {
        return p.value;
      },
      updater: 'setSliderValue'
    },
    _active: {
      value: function value(p) {
        return false;
      },
      updater: 'setActive'
    },
    _unfocusedClickProcess: {
      value: function value(p) {
        return false;
      },
      updater: 'setUnfocusedClickProcess'
    }
  },
  lifecycles: {
    UNSAFE_componentWillUpdate: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.value !== nextProps.value) this.props.setSliderValue(nextProps.value);
    }
  },
  handlers: {
    handleOnBeforeChange: function handleOnBeforeChange(p) {
      return function (value, e) {
        var _context;

        var unfocusedClick = _indexOfInstanceProperty(_context = document.activeElement.className).call(_context, 'rc-slider-handle') === -1;

        if (!p.isDisabled) {
          if (unfocusedClick && !p._unfocusedClickProcess) {
            p.setUnfocusedClickProcess(true);
          } else {
            p.setActive(true); // because our _formatMarks function uses memoization, we can call it here with almost no performance hit

            p.onBeforeChange(e, _extends({
              value: value
            }, p.steps[value], {
              id: p.id,
              label: _formatMarks(p)[value]
            }));
          }
        }
      };
    },
    handleOnChange: function handleOnChange(p) {
      return function (value, e) {
        //WYN-4668 [Victor]: basically this: http://www.lukekedz.com/rc-slider-onafterchange-event-behavior/
        var _activeElementCls = document.activeElement.className;
        var focusedClick = _activeElementCls === 'rc-slider-handle rc-slider-handle-click-focused';
        var unfocusedClick = _indexOfInstanceProperty(_activeElementCls).call(_activeElementCls, 'rc-slider-handle') === -1;

        var isDragging = _indexOfInstanceProperty(_activeElementCls).call(_activeElementCls, 'rc-slider-handle') !== -1 && p._active;

        if (!p.isDisabled && (unfocusedClick || focusedClick || isDragging)) {
          p.setSliderValue(value); // because our _formatMarks function uses memoization, we can call it here with almost no performance hit

          p.onChange(e, _extends({
            value: value
          }, p.steps[value], {
            id: p.id,
            label: _formatMarks(p)[value]
          }));
        }
      };
    },
    handleOnAfterChange: function handleOnAfterChange(p) {
      return function (value, e) {
        var _activeElementCls = document.activeElement.className;
        var focusedClick = _activeElementCls === 'rc-slider-handle rc-slider-handle-click-focused';

        var isDragging = _indexOfInstanceProperty(_activeElementCls).call(_activeElementCls, 'rc-slider-handle') !== -1 && p._active;

        if (!p.isDisabled) {
          if (focusedClick && isDragging) p.setUnfocusedClickProcess(false);
          p.setActive(false); // because our _formatMarks function uses memoization, we can call it here with almost no performance hit

          p.onAfterChange(e, _extends({
            value: value
          }, p.steps[value], {
            id: p.id,
            label: _formatMarks(p)[value]
          }));
        }
      };
    }
  },
  render: function render(props) {
    var _minValue, _maxValue, _stepSize;

    logger.warn('Slider: setting a `stepLabelWidth` when the `stepLabelPosition` is `bottom` will have no effect on label width', props.stepLabelPosition !== positions.RIGHT && props.stepLabelWidth !== undefined);
    logger.warn('Slider: setting a `minValue` when providing "steps" will have no effect on minValue of the slider', !!props.minValue && !_.isEmpty(props.steps));
    logger.warn('Slider: setting a `maxValue` when providing "steps" will have no effect on minValue of the slider. We will use the size of your steps array as maxValue', !!props.maxValue && !_.isEmpty(props.steps));
    logger.warn('Slider: setting a `stepSize` when providing "steps" will have no effect on step size. It will always be 1.', !!props.stepSize && !_.isEmpty(props.steps));

    if (_.isEmpty(props.steps)) {
      _minValue = props.minValue || 0;
      _maxValue = props.maxValue || 1;
      _stepSize = props.stepSize || 1;
    } else {
      _minValue = 0;
      _maxValue = props.steps.length - 1;
      _stepSize = 1;
    }

    var _marks = _formatMarks(props);

    var _cls = cx('ck', 'slider', "label-position--" + props.stepLabelPosition, {
      inverted: props.isInverted,
      active: props._active,
      fluid: props.isFluid,
      disabled: props.isDisabled,
      animated: props.animationEnabled
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, !!props.label ? /*#__PURE__*/React.createElement(Label, {
      text: props.label
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "slider-inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slider-inner__slider"
    }, /*#__PURE__*/React.createElement(RCSlider, {
      id: props.id,
      min: _minValue,
      max: _maxValue,
      step: _stepSize,
      value: props._sliderValue,
      marks: props.stepLabelPosition === positions.BOTTOM ? _marks : undefined,
      onBeforeChange: props.handleOnBeforeChange,
      onChange: props.handleOnChange,
      onAfterChange: props.handleOnAfterChange
    })), props.stepLabelPosition === positions.RIGHT ? /*#__PURE__*/React.createElement("div", {
      className: "slider-inner__label",
      style: {
        width: props.stepLabelWidth
      }
    }, /*#__PURE__*/React.createElement(Label, {
      text: "" + _marks[props._sliderValue],
      hasPadding: true
    })) : null));
  }
}); // memoized function will use cache unless one of the passed in props is changed

var _formatMarks = _.memoize(function (_ref) {
  var minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      stepSize = _ref.stepSize,
      steps = _ref.steps,
      formatStepLabel = _ref.formatStepLabel;
  var _marks = {};

  if (_.isEmpty(steps)) {
    // we don't have labels so we're going to build an object from the min, max and step values
    _.times(Math.round(maxValue - minValue + 1) / (stepSize || 1), function (n) {
      _marks[n] = formatStepLabel(n);
    });
  } else {
    _marks = _reduceInstanceProperty(_).call(_, steps, function (acc, x, i) {
      acc[i] = formatStepLabel(steps[i].label);
      return acc;
    }, {});
  }

  return _marks;
}, function (_ref2) {
  var minValue = _ref2.minValue,
      maxValue = _ref2.maxValue,
      stepSize = _ref2.stepSize,
      steps = _ref2.steps;
  return _JSON$stringify({
    minValue: minValue,
    maxValue: maxValue,
    stepSize: stepSize,
    steps: steps
  });
});

export var PrivateSlider = Slider;
export default whitelistStyles()(Slider);
//# sourceMappingURL=index.js.map